module.exports = __webpack_public_path__ + "static/chirurgia-palca-image-2-3da4a1758156032e76745b1987f62560.png";